
if ( typeof VideoBackgroundElement !== 'function' ) {

  class VideoBackgroundElement extends HTMLElement {

    constructor(){

      super();

      this._eventSuccess = new Event('success');
      this._eventFail = new Event('fail');
      const video = this.querySelector('video');
      video.addEventListener('error', e=>{
        this.switchFallback();
      })
      const markLoaded = () => {
        if ( ! this.classList.contains('loaded') ) {
          this.classList.add('loaded');
          this.dispatchEvent(this._eventSuccess);
        }
      };
      /* First frame ready — much sooner than "playing" when autoplay is delayed */
      video.addEventListener('loadeddata', markLoaded);
      video.addEventListener('playing', markLoaded);
      video.addEventListener('stalled', e=>{
        if ( ! this.classList.contains('loaded') ) {
          this.switchFallback();
        }
      })

      const startVideo = () => {
        video.querySelectorAll('source').forEach(elm=>{
          if (elm.dataset.src) elm.src = elm.dataset.src;
        });
        video.load();
        const playPromise = video.play();
        if ( playPromise !== undefined ) {
          playPromise.catch(()=>{});
        }
      };

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        if ( ( entries[0].target.querySelector('video-background-element') && ! entries[0].target.querySelector('video-background-element').classList.contains('loaded') ) || ( entries[0].tagName == 'video-background-element') && ! entries[0].target.classList.contains('loaded') ) {
          startVideo();
        }
        observer.unobserve(this);
      }

      const vh = window.innerHeight || document.documentElement.clientHeight || 0;
      const rect = this.getBoundingClientRect();
      const parentRect = this.parentNode ? this.parentNode.getBoundingClientRect() : { top: 0, bottom: 0 };
      const nearViewport =
        (rect.top < vh + 600 && rect.bottom > -600) ||
        (parentRect.top < vh + 600 && parentRect.bottom > -600);
      if (nearViewport) {
        startVideo();
      } else {
        const ioOpts = { rootMargin: '0px 0px 1200px 0px', threshold: 0.01 };
        const obs = new IntersectionObserver(handleIntersection.bind(this), ioOpts);
        obs.observe(this);
        if (this.parentElement) obs.observe(this.parentElement);
      }
      
    }

    switchFallback(){
      const fallback = this.parentElement.querySelector(`[data-video-background-fallback][data-id="${this.dataset.id}"]`);
      if ( fallback ) {
        fallback.append(fallback.querySelector('template').content.cloneNode(true));
        fallback.querySelector('img').setAttribute('srcset', fallback.querySelector('img').getAttribute('srcset'));
      }
      this.dispatchEvent(this._eventFail);
    }

  }

  if ( typeof customElements.get('video-background-element') == 'undefined' ) {
    customElements.define('video-background-element', VideoBackgroundElement);
  }

}

document.addEventListener('shopify:section:load', e=>{
  if ( e.target.classList.contains('mount-video-background') ) {
    setTimeout(()=>{
      e.target.querySelectorAll('video-background-element').forEach(elm=>{
        elm.querySelectorAll('source').forEach(source=>{
          if (source.dataset.src) source.src = source.dataset.src;
        })
        const v = elm.querySelector('video');
        v.load();
        const p = v.play();
        if ( p !== undefined ) p.catch(()=>{});
      });
    }, 500);
  }
});